export default {
    props: {
        /**
         * 0 - means no chunks
         */
        chunkSize: {
            type: [Number, String],
            default: 0
        }
    },
    methods: {
        getChunksCount(items) {
            let chunkSize = parseInt(this.chunkSize)

            if(chunkSize === 0) {
                return 1
            }

            return Math.ceil(items.length / chunkSize)
        },
        getChunk(items, chunkNum) {
            let chunkSize = parseInt(this.chunkSize)

            if(chunkSize === 0) {
                return items
            }

            return items.slice(
                (chunkNum - 1) * chunkSize,
                chunkNum * chunkSize
            )
        }
    }
}
